
/**
 * Available organization user role types.
 */
export type MobizOrganizationRole =
  /**
   * Owner of the Organization.  Can disable account and manage billing.
   * Owner also contains all permissions of Administrator, User and Guest.
   */
  'Owner' |
  /**
   * Administrator of Organization.  Can invite other users.
   * Administrator also contains all permissions of User and Guest.
   */
  'Administrator' |
  /**
   * Organization User.  Has corresponding ERP credentials.
   */
  'User' |
  /**
   * Guest user.  Can only view ERP data, not execute any operation against ERP system.
   */
  'Guest' |
  /**
   * No role for the given Organization
   */
  'None';
